module.exports = __webpack_public_path__ + "img/img_kiwoom_cnt3.0fc42f03.png";